import { chakra } from '@chakra-ui/react'
import { isValidMotionProp, motion } from 'framer-motion'

export const ChakraMotionDiv = chakra(motion.div, {
  shouldForwardProp: (prop) => (isValidMotionProp(prop) || prop === 'children') || prop === 'onMouseEnter' || prop === 'onMouseLeave',
})